/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { SalesApiConfiguration } from '../sales-api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { SamPolicyInsuranceDataCompositeRegistryRequestDtoDto } from '../models/sam-policy-insurance-data-composite-registry-request-dto-dto';
import { SamPolicyInsuranceDataCompositeRegistryResponseDto } from '../models/sam-policy-insurance-data-composite-registry-response-dto';


/**
 * the PolicyCompositeRegistration API
 */
@Injectable({
  providedIn: 'root',
})
export class PolicyCompositeRegistrationService extends BaseService {
  constructor(
    config: SalesApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation updateCompositeRegistrationData
   */
  static readonly UpdateCompositeRegistrationDataPath = '/policy/composite/registration';

  /**
   * Update policy registration data as composite process
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateCompositeRegistrationData()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateCompositeRegistrationData$Response(params: {

    /**
     * Caller
     */
    caller: 'API' | 'FEC';
    'X-Authorization'?: string;
    body: SamPolicyInsuranceDataCompositeRegistryRequestDtoDto
  },
  context?: HttpContext

): Observable<StrictHttpResponse<SamPolicyInsuranceDataCompositeRegistryResponseDto>> {

    const rb = new RequestBuilder(this.rootUrl, PolicyCompositeRegistrationService.UpdateCompositeRegistrationDataPath, 'put');
    if (params) {
      rb.query('caller', params.caller, {});
      rb.header('X-Authorization', params['X-Authorization'], {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SamPolicyInsuranceDataCompositeRegistryResponseDto>;
      })
    );
  }

  /**
   * Update policy registration data as composite process
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateCompositeRegistrationData$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateCompositeRegistrationData(params: {

    /**
     * Caller
     */
    caller: 'API' | 'FEC';
    'X-Authorization'?: string;
    body: SamPolicyInsuranceDataCompositeRegistryRequestDtoDto
  },
  context?: HttpContext

): Observable<SamPolicyInsuranceDataCompositeRegistryResponseDto> {

    return this.updateCompositeRegistrationData$Response(params,context).pipe(
      map((r: StrictHttpResponse<SamPolicyInsuranceDataCompositeRegistryResponseDto>) => r.body as SamPolicyInsuranceDataCompositeRegistryResponseDto)
    );
  }

  /**
   * Path part for operation createCompositeRegistrationData
   */
  static readonly CreateCompositeRegistrationDataPath = '/policy/composite/registration';

  /**
   * Create new policy registration data as composite process
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createCompositeRegistrationData()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createCompositeRegistrationData$Response(params: {

    /**
     * Caller
     */
    caller: 'API' | 'FEC';
    'X-Authorization'?: string;
    body: SamPolicyInsuranceDataCompositeRegistryRequestDtoDto
  },
  context?: HttpContext

): Observable<StrictHttpResponse<SamPolicyInsuranceDataCompositeRegistryResponseDto>> {

    const rb = new RequestBuilder(this.rootUrl, PolicyCompositeRegistrationService.CreateCompositeRegistrationDataPath, 'post');
    if (params) {
      rb.query('caller', params.caller, {});
      rb.header('X-Authorization', params['X-Authorization'], {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SamPolicyInsuranceDataCompositeRegistryResponseDto>;
      })
    );
  }

  /**
   * Create new policy registration data as composite process
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createCompositeRegistrationData$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createCompositeRegistrationData(params: {

    /**
     * Caller
     */
    caller: 'API' | 'FEC';
    'X-Authorization'?: string;
    body: SamPolicyInsuranceDataCompositeRegistryRequestDtoDto
  },
  context?: HttpContext

): Observable<SamPolicyInsuranceDataCompositeRegistryResponseDto> {

    return this.createCompositeRegistrationData$Response(params,context).pipe(
      map((r: StrictHttpResponse<SamPolicyInsuranceDataCompositeRegistryResponseDto>) => r.body as SamPolicyInsuranceDataCompositeRegistryResponseDto)
    );
  }

}
